import { render, staticRenderFns } from "./myMechanism.vue?vue&type=template&id=01c73f32&scoped=true"
import script from "./myMechanism.vue?vue&type=script&lang=ts"
export * from "./myMechanism.vue?vue&type=script&lang=ts"
import style0 from "./myMechanism.vue?vue&type=style&index=0&id=01c73f32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c73f32",
  null
  
)

export default component.exports